import React from 'react';

import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useTranslation } from '../../translations';

const CreditCardInfoCard: React.FC = () => {
    const translated = useTranslation().creditCardScreen;

    return (
        <InfoCard className="credit-card-application__info" skipBackground>
            <RichIcon className="credit-card-application__icon" type={RichIconTypes.DIGITALTKORT_MOBIL} />
            <InfoCard.TitleH2>{translated.infoTitle}</InfoCard.TitleH2>
            <p className="credit-card-application__paragraph">{translated.infoText}</p>
        </InfoCard>
    );
};

export default CreditCardInfoCard;
